import { render, staticRenderFns } from "./LoginFromApp.vue?vue&type=template&id=0a0cc9ac&"
import script from "./LoginFromApp.vue?vue&type=script&lang=js&"
export * from "./LoginFromApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports